import Meta from '@/components/common/Meta'

import StorageForSummerPage from '@/v2/components/pages/landing-pages/storage-for-summer-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/storage-for-summer-page'

interface StorageForSummerPageProps {}

const Page: React.FC<StorageForSummerPageProps> = () => {
  return (
    <>
      <Meta
        title={LANDING_PAGES_META_CONTENTS.storage_for_summer.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''}
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_for_summer?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_for_summer?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StorageForSummerPage />
    </>
  )
}

export default Page
